import React, { useEffect, useState } from 'react'
import {
  GridColumn as Column,
  Grid,
  GridCellProps,
  GridDetailRow,
  GridExpandChangeEvent,
} from '@progress/kendo-react-grid'
import { TradingAccountOpenPositionsDto } from 'api/Clients/Types/TradingAccountOpenPositionsDto'
import { Loading } from 'components/Loading'
import { formatLocalDateUTC } from 'utils/date'
import { TableWithExport } from 'utils/table/withExport'

import '../TradingAccount.scss'

class DetailComponent extends GridDetailRow {
  render() {
    const data = this.props.dataItem
    if (data) {
      return (
        <Grid data={data.openTrades} resizable>
          <Column
            field='orderNumber'
            title='Order Number'
            className='trading-account-table-columns__number'
          />
          <Column
            cell={(props: GridCellProps) => (
              <td className='table-columns__date'>
                {formatLocalDateUTC(props.dataItem.openTime, true)}
              </td>
            )}
            title='Open Time'
            className='trading-account-table-columns__date'
          />
          <Column field='type' title='Type' className='trading-account-table-columns__content' />
          <Column
            field='symbol'
            title='Symbol'
            className='trading-account-table-columns__content'
          />
          <Column field='lots' title='lots' className='trading-account-table-columns__number' />
          <Column
            field='openPrice'
            title='Open Price'
            className='trading-account-table-columns__number'
          />
          <Column
            field='stopLossPrice'
            title='StopLossPrice'
            className='trading-account-table-columns__number'
          />
          <Column
            field='takeProfitPrice'
            title='TakeProfitPrice'
            className='trading-account-table-columns__number'
          />
          <Column
            field='currentPrice'
            title='Current Price'
            className='trading-account-table-columns__number'
          />
          <Column
            field='commission'
            title='Commission'
            className='trading-account-table-columns__number'
          />
          <Column field='swaps' title='Swaps' className='trading-account-table-columns__number' />
          <Column field='pnL' title='PNL' className='trading-account-table-columns__number' />
        </Grid>
      )
    }
    return (
      <div style={{ height: '50px', width: '100%' }}>
        <div style={{ position: 'absolute', width: '100%' }}>
          <div className='k-loading-image' />
        </div>
      </div>
    )
  }
}

interface Props {
  data: {
    id: string
    name: string
  }
  tradingAccountPositions: TradingAccountOpenPositionsDto[]
}

const TradingAccountPositionsTable: React.FC<Props> = ({ data, tradingAccountPositions }) => {
  const [openPositions, setOpenPositions] = useState<TradingAccountOpenPositionsDto[]>([])

  useEffect(() => {
    if (tradingAccountPositions) {
      setOpenPositions(tradingAccountPositions)
    }
  }, [tradingAccountPositions, data])

  const handleExpandChange = (event: GridExpandChangeEvent) => {
    const newData = openPositions.map((item) =>
      item.login === event.dataItem.login && item.symbol === event.dataItem.symbol
        ? { ...item, expanded: event.value }
        : { ...item, expanded: false }
    )
    setOpenPositions(newData)
  }

  return (
    <React.Fragment>
      <Loading isLoading={!tradingAccountPositions}>
        <TableWithExport data={tradingAccountPositions || []}>
          <Grid
            resizable
            data={openPositions}
            detail={DetailComponent}
            expandField='expanded'
            onExpandChange={handleExpandChange}
          >
            <Column
              field='symbol'
              title='Symbol'
              className='trading-account-table-columns__content'
            />
            <Column field='lots' title='Lots' className='trading-account-table-columns__number' />
            <Column
              field='vwap'
              title='Volume Weighted Avg Price'
              className='trading-account-table-columns__number'
            />
            <Column field='pnL' title='PNL' className='trading-account-table-columns__number' />
          </Grid>
        </TableWithExport>
      </Loading>
    </React.Fragment>
  )
}

export default TradingAccountPositionsTable
